import renderFromPreloadedJSON from "../renderFromPreloadedJSON";

export default async () => {
  if (document.querySelector("[data-hypernova-key=VideoModal]")) {
    const { default: VideoModal } = await import("./VideoModal");
    renderFromPreloadedJSON(VideoModal, "VideoModal", true);
  }
};
